import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function query(payload) {
  return request(`/iwms-wms/wms/physicscheckpool/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function getDetail(payload) {
  return request(`/iwms-wms/wms/physicscheckpool/getByGroupFilter?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}&checkBillNumber=${payload.checkBillNumber}&articleUuid=${payload.articleUuid}&stockBatch=${payload.stockBatch}&orderBillNumber=${payload.orderBillNumber}`);
}

export async function quality(payload) {
  return request(`/iwms-wms/wms/physicscheckbill?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}`, {
    method: 'POST',
    body: payload.items,
  });
}

export async function singleQuality(payload) {
  return request(`/iwms-wms/wms/physicscheckbill/add?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}`, {
    method: 'POST',
    body: payload.items,
  });
}
